var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAarp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_11791)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1909_11791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4035 31.9022C60.4035 30.4107 59.6162 29.3328 58.0832 29.3328H57.0884V34.4294H58.0832C59.5332 34.4294 60.4035 33.4768 60.4035 31.9022ZM45.859 31.9022C45.859 30.5345 45.1547 29.3328 43.2896 29.3328H42.5438V34.4294H43.2896C44.9887 34.4294 45.859 33.4768 45.859 31.9022ZM30.4448 34.9275L28.9117 30.8666L27.3787 34.9275C27.4617 34.9275 28.2905 34.8029 28.9117 34.8029C29.616 34.8445 30.3618 34.9275 30.4448 34.9275ZM18.0967 35.0105L16.5637 30.8257L15.0721 34.8451C15.3205 34.8451 15.611 34.8451 15.9009 34.8451C17.1026 34.8451 17.9729 35.0111 18.0967 35.0111V35.0105ZM65.5001 31.9022C65.5001 34.8445 63.1797 36.7089 59.3672 36.7089H57.0884V40.7698H46.7293L42.5445 35.2588V40.7698H32.5168L31.3981 37.7452C31.3151 37.7452 30.1964 37.5383 28.9117 37.5383C27.5856 37.5383 26.4254 37.7452 26.3839 37.7452L25.2652 40.7698H20.1687L19.3399 38.4495C20.5831 38.7808 21.5357 39.2782 22.0331 39.5681L22.24 39.0292C21.4527 38.5733 19.2977 37.4962 16.2316 37.4962C13.8283 37.4962 12.2952 38.0766 9.80888 38.0766C5.78948 38.0766 3.01326 36.1291 2.8479 36.0046L3.92505 33.3944C4.21493 33.5604 6.8673 35.3004 9.97491 35.3004C10.5138 35.3004 10.9282 35.2588 11.3834 35.2173L14.7401 27.0547H20.2925L23.6077 35.6317L27.1297 27.0547H32.6821L37.5718 39.7341V27.0962H44.2014C48.7182 27.0962 50.9555 29.1682 50.9555 31.9029C50.9555 34.6376 48.8005 35.7147 48.1793 35.9638L52.0742 40.19V27.0962H59.3257C63.3866 27.0962 65.4994 29.1266 65.4994 31.9029L65.5001 31.9022ZM13.7874 38.2011L12.8756 40.7705H9.10462L10.0164 38.5331H10.0579C10.2648 38.5747 12.0054 38.5325 13.7874 38.2011Z",
    fill: "#F4F4F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1909_11791",
    x: -77.1521,
    y: -52.9453,
    width: 222.652,
    height: 173.716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0784314 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_11791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_11791",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_11791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAarp);
export default __webpack_public_path__ + "static/media/icon-aarp.ed4660f4833f8ff8c87fa9b63a15712f.svg";
export { ForwardRef as ReactComponent };